import type { MouseEventHandler, ReactNode } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { Icon } from "../Icon";

interface FilterButtonV2Props {
  children: ReactNode;
  className?: string;
  hasValue?: boolean;
  isFocused?: boolean;
  onClear?: MouseEventHandler<HTMLButtonElement>;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  shouldShowClearButton?: boolean;
}

export const FilterButtonV2 = ({
  children,
  hasValue = false,
  isFocused = false,
  onClear,
  onClick,
  shouldShowClearButton = true,
  className,
}: FilterButtonV2Props) => (
  <button
    type="button"
    className={classNames(
      "hover:bg-secondary bg-primary focus-visible:border-secondary group relative flex h-8 items-center rounded-3xl border px-[18px] py-1.5 text-xs transition-colors disabled:cursor-not-allowed disabled:opacity-50",
      isFocused ? "text-dark border-light" : "text-default",
      hasValue && "border-darkest",
      className,
    )}
    onClick={onClick}
  >
    {children}
    {hasValue && shouldShowClearButton && onClear && (
      <button
        type="button"
        className="bg-primary absolute right-1 top-1/2 hidden size-6 -translate-y-1/2 items-center justify-center rounded-3xl shadow-sm transition-all hover:shadow-md hover:outline hover:outline-1 group-hover:flex"
        onClick={onClear}
      >
        <Icon
          type="14-close"
          useWithStrokeCurrentColor
          size={14}
          className="!w-3.5"
        />
      </button>
    )}
  </button>
);
